<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">中国服务贸易协会信息技术服务委员会简介</span>
      </div>
      <div class="pt-28">
        <p>
          中国服务贸易协会信息技术服务委员会(英文缩写 ITSU)
          是经中华人民共和国民政部、商务部正式批准成立，促进中国 IT
          服务市场新格局的非营利性社会团体，接受中国服务贸易协会直接领导。中国服务贸易协会信息技术服务委员会由中国石化、北明软件、贤牛科技等30多家企业及社会组织共同发起成立，总部设在北京。
        </p>
        <h3>一、宗旨</h3>
        <p>
          立足IT服务行业资源整合、优化提升，立足国内、走向国际，
          提供服务和支撑。
        </p>
        <h3>二、基本定位</h3>
        <p>1. 推动形成 IT 服务贸易双循环大格局和中国在全球 IT
          服务供应链体系中的领导地位；</p>
        <p>2. 促进国内 IT 服务营商环境优化、推动 IT
          服务市场规范化、 协调解决 IT 服务贸易纠纷；</p>
        <p>3.应用新兴科技与互联网商业理念，推动 IT 服务供应链平台化
          和数智化发展新场景；</p>
        <p>4.促进 IT 服务业态升级，探索创新新模式； </p>
        <p>5.推动IT 服务领域的碳排放交易体系建立，协力构建 IT 后市场的绿色发展新格局；</p>
        <p>6.推动服务商资格认证。</p>
        <h3>三、工作内容</h3>
        <p>严格遵守国家法律、法规和有关政策依照章程独立自主地开展活动。为会员提供相关服务，维护行业、会员的合法权益和共同经济利益，维护市场秩序和公平竞争。 </p>
        <p>1.推动 IT 服务领域的行业研究，向政府部门、监管单位、商业企业、社会团体等提供行业研究报告。</p>
        <p>2. 制定并发布行业标准、团体标准，从而形成规范有效的 IT 服务管理体系与机制。</p>
        <p>3. 开展IT 服务应用研究课题，推动研究课题的落地实践，为会员企业、各级政府、各行业管理机构提供前瞻性、战略性的课题研究成果。</p>
        <p>4. 充分发挥协会平台职能，联合国家级研究院、政府监管部门、权威研究机构，专家院士，法律机构形成行业报告、企业发展报告等，为企业制定发展战略提供决策支持。</p>
        <p>5. 广泛组织开展行业企业的相关培训学习、交流会议，搭建行业企业的沟通平台和服务平台，专业服务企业会员和个人会员以及相关高校、学术机构与专业人士等。为上述行业主体提供交流与合作机 会，为会员创造价值。</p>
        <p>6. 反映会员的利益诉求，协助有关部门为企业提供政策法规解读、法律咨询服务，维护行业、会员的合法权益，客观、公正地调解会员之间、会员与非会员之间、会员与消费者之间的矛盾纠纷，守法经营，维护正常市场秩序和社会稳定。</p>
        <p>7. 为各行各业的创新技术、创新产品、创新模式、创新服务、创新品牌等提供推广服务支持。</p>
        <p>8.积极推动会员企业为新产品、开拓市场，发布市场信息，开展行业培训、交流、咨询、展览展销、会议筹办等提供活动支持。</p>
      </div>
   </div>
</template>
<script>
export default {
};
</script>
<style lang="less" scoped>
.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f5f6a;
    line-height: 28px;
    margin-bottom: 30px;
  }
  h3 {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #171717;
    line-height: 30px;
    margin-bottom: 20px;
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
